import { render } from "./PromocodeDetail.vue?vue&type=template&id=51a1b3a5"
import script from "./PromocodeDetail.vue?vue&type=script&lang=js"
export * from "./PromocodeDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__